import { useCallback } from 'react';
import { postUpdateInsuranceInfoApi } from '@/api/bodyAndPaint';
import { UpdateInsuranceInfoParams } from '@/types/api/bodyAndPaint';

interface PostUpdateInsuranceInfoHookProps {
  params: UpdateInsuranceInfoParams;
}
export const usePostUpdateInsuranceInfo = ({
  params,
}: PostUpdateInsuranceInfoHookProps) => {
  const postRequest = useCallback(async () => {
    try {
      if (params) {
        const fetch = await postUpdateInsuranceInfoApi(params);
        return fetch;
      } else {
        throw 'invalid params';
      }
    } catch (error) {
      console.error(error);
    }
  }, [params]);

  return { postRequest };
};
